module.exports = __webpack_public_path__ + "img/Logo_small.f38f0034.png";